export default "__VITE_ASSET__Dh6sv$re__"